<template>
    <div>
        <!-- <subNavbar :list="nav.anlixinshang" @click="subNavbarItemClick"/> -->
        <div>
            <img src="../assets/banner/案例欣赏banner1920x280px.png">
        </div>
        <div class="container margin-auto margin-top-30">
            <orderMenu :isHtml="false" @change="orderMenuChange" :list="nav.anlixinshang" ref="orderMenu">
                <div class="flex flex-wrap">
                    <div class="item" :class="{ 'item-margin': marginFn(index) }" v-for="(item, index) in list" :key="index"
                        @click="jump(item)">
                        <div class="img">
                            <img :src="item.litpic">
                        </div>
                        <div class="p">
                            {{ item.title }}
                        </div>
                    </div>
                </div>
                <div class="flex justify-center margin-top">
                    <el-pagination :current-page.sync="page" :page-size="6" @current-change="currentChange" background
                        layout="prev, pager, next" :total="total">
                    </el-pagination>
                </div>
            </orderMenu>
        </div>
    </div>
</template>

<script>
import subNavbar from '../components/subNavbar'
import orderMenu from '../components/orderMenu'
import { mapGetters, mapMutations } from 'vuex'
import { getCaselist } from '@/api/api'
export default {
    name: 'Case',
    components: {
        subNavbar,
        orderMenu
    },
    computed: {
        ...mapGetters({
            nav: 'getNav'
        })
    },
    watch: {
        nav(newsVal) {
            // console.log(newsVal)
            if (this.nav.anlixinshang.length > 0) {
                this.type = this.nav.anlixinshang[this.$route.query.index ? this.$route.query.index : 0].id
                this.getCaselist(this.type, 1)
            }
        },
        '$route': 'getIndex'
    },
    data() {
        return {
            list: [

            ],
            page: 1,
            type: 1,
            total: 0,
            index: 0
        }
    },
    methods: {
        getCaselist(typeid, page) {
            // console.log(typeid)
            let data = {
                typeid: typeid,
                page: page,
                limit: 6
            }
            getCaselist(data).then(res => {
                if (res.code == 1) {
                    this.list = res.data
                    this.total = res.count
                    // console.log(this.total)
                }
            })
        },
        orderMenuChange(index) {
            this.index = index
            let item = this.$refs.orderMenu.getItem()
            this.type = item.id
            this.page = 1
            this.getCaselist(this.type, 1)
        },
        currentChange(e) {
            // console.log(this.type)
            // this.page=1
            this.getCaselist(this.type, e)
        },
        subNavbarItemClick(index) {
            this.index = index

            this.$refs.orderMenu.setActive(index)
            this.getCaselist(this.nav.anlixinshang[index].id, 1)
        },
        getIndex() {
            // console.log(this.$route.query.index)
            this.subNavbarItemClick(this.$route.query.index)
        },
        marginFn(index) {
            // console.log(index)
            let res = false
            if (index == 1 || index == 4 || index == 7 || index == 10 || index == 13) {
                res = true
            }
            return res
        },
        jump(item) {
            this.$router.push({ path: '/CaseDetail', query: { id: item.id, index: this.index, pid: this.type } })
        }
    },
    mounted() {
        if (this.$route.query.index) {
            this.index = this.$route.query.index
            this.subNavbarItemClick(this.$route.query.index)
        }

        if (this.nav.anlixinshang.length > 0) {
            this.type = this.nav.anlixinshang[this.$route.query.index ? this.$route.query.index : 0].id
            // console.log(this.type)
            this.getCaselist(this.type, 1)
        }

        // console.log(this.$route.query.index)
    }
}
</script>

<style lang="scss" scoped>
.item {
    width: 280px;
    height: 240px;
    cursor: pointer;
}

.item-margin {
    margin-left: 20px;
    margin-right: 20px;
}

.item>.img {
    width: 280px;
    height: 200px;
    // background: #CEB49A;
}

.item>.img img {
    height: 200px;
    width: 280px;
}

.item>.p {
    font-size: 14px;
    font-weight: 400;
    color: #757575;
    margin-top: 5px;
    margin-bottom: 10px;
}
</style>